import React from 'react';

import type { SubheadingComponent } from '../../../../../core/data-sources/content-components/types.js';

interface SubheadingProps {
  item: SubheadingComponent;
}

const Subheading: React.FC<SubheadingProps> = ({ item }) => (
  <h2 className="subheading">
    {item.presentationProperties?.number && (
      <div className="subheading-content">
        {item.presentationProperties.number}
      </div>
    )}
    {item.text.value}
  </h2>
);

export default Subheading;
